import { ChangeEvent } from 'react'
import Input from './Input'
import Label from './styled/Label'
import TextBox from './TextBox'

type Props = {
    label: string
    type: React.ComponentProps<typeof Input>['type']
    value?: string
    error?: string
    placeholder?: string
    onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void
    className?: React.HTMLAttributes<HTMLDivElement>['className']
    disabled?: boolean
    maxLength?: number
}

const TextBoxField = (props: Props) => {
    return (
        <div className={props.className}>
            <Label>
                {props.label}{' '}
                {props.maxLength && (
                    <span>
                        - {(props.value || '').length}/{props.maxLength}
                    </span>
                )}
            </Label>
            <TextBox
                maxLength={props.maxLength}
                disabled={props.disabled}
                placeholder={props.placeholder}
                rows={10}
                className="h-40 font-normal w-full rounded shadow border-1 border-primary/[.15] focus:border-primary text-white"
                value={props.value}
                onChange={props.onChange}
            />
            {props.error && (
                <span className="text-xxs text-red-500">{props.error}</span>
            )}
        </div>
    )
}

export default TextBoxField
